<template>
  <v-layout
      flex-child
      wrap
      style="height:100vh"
    >
    <v-flex xs6>
      <img
        src="../../assets/logo.png"
        height="70px"
        @click="window.location.replace('https://www.smartpress.co')"
        style="position:absolute;left:30px;top:20px;margin-left:0px;cursor:pointer;  "
      >
      <div style="width:40%;transform: translateX(40%) translateY(50%);">
          <h2>Change Password</h2>
          <p>Request a password change.</p>
           
            <b-form-group
              label="Current Password:"
              label-for="currentPasswordInput">
              <b-form-input 
                id="currentPasswordInput"
                type="password"
                v-model="currentPassword"
                required
                placeholder="Enter Current Password"/>
            </b-form-group>
            <b-form-group
              label="New Password:"
              label-for="newPasswordInput">
              <b-form-input 
                id="newPasswordInput"
                type="password"
                v-model="newPassword"
                required
                placeholder="Enter New Password"/>
            </b-form-group>
            <b-button 
              type="submit" 
              variant="primary"
              @click="passwordChange">Submit</b-button>
          
          <v-alert/>
        </div>
       
    </v-flex>
     <v-flex style="background-color:white" xs6> 
      <img style="margin-top:0vh" height="1600px" src="../../assets/Art/spLoginArkwork-01.png">
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue"

import { mapGetters } from "vuex"
import router from "@/router"
import store from "@/store"

import Alert from "@/components/auth/Alert.vue"

Vue.component("v-alert", Alert)

export default {
  data() {
    return {
      currentPassword: "",
      newPassword: ""
    }
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    async passwordChange() {
      await store.dispatch("auth/passwordChange", {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      })
      if (!this.hasAuthenticationStatus) {
        router.push("dashboard")
      }
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}
</style>